import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { LocalStorageService } from '../services/LocalStorageService';

export default function AppNavBar() {

  const [email, setEmail] = React.useState(null);

  React.useEffect(() => {
    setEmail(LocalStorageService.getEmail());
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    window.location.pathname = "/";
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ backgroundColor: '#FFFFFE' }} elevation={0}>
        <Toolbar>
          <img src="logo2.png" alt="Logo" style={{ height: 50 }} />
          <div style={{ flexGrow: 1 }} />

          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            {/* Logout Button with margin */}
            <Button
              variant="contained"
              sx={{
                bgcolor: "#352c1d",
                boxShadow: "none",
                marginTop: 2  // Added margin to push the logout button down
              }}
              onClick={handleLogout}>
              Logout
            </Button>

            {/* Email below the Logout button */}
            <Typography variant="body1" color="#000000" sx={{ fontWeight: "bold", color: "#5a5a5a", marginTop: 1 }}>
              {email}
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}